import type { SocialLink } from "../config/site";
import { Icon } from "./Icon";

type SocialLinksProps = {
  readonly links: readonly SocialLink[];
};

export function SocialLinks({ links }: SocialLinksProps) {
  return (
    <nav
      className="flex flex-col gap-2.5 self-end max-[900px]:ml-auto max-[900px]:w-full max-[900px]:max-w-[520px] min-[901px]:col-start-2 min-[901px]:row-span-2 min-[901px]:row-start-1"
      aria-label="Find Kalkonen online"
    >
      {links.map((link) => (
        <a
          className="group relative isolate grid min-h-[82px] grid-cols-[42px_1fr_24px] items-center gap-[17px] overflow-hidden bg-[linear-gradient(90deg,rgba(8,9,8,.62),rgba(8,9,8,.2))] px-4 no-underline backdrop-blur-[3px] transition-transform duration-200 before:absolute before:inset-y-0 before:left-0 before:w-px before:origin-center before:scale-y-0 before:bg-accent before:transition-transform before:duration-200 after:absolute after:inset-0 after:-z-10 after:bg-accent/[.045] after:opacity-0 after:transition-opacity after:duration-200 hover:translate-x-1 hover:before:scale-y-100 hover:after:opacity-100 max-[620px]:min-h-[76px] max-[620px]:grid-cols-[38px_1fr_22px] max-[620px]:gap-3 max-[620px]:px-3"
          href={link.href}
          itemProp="sameAs"
          target="_blank"
          rel="noopener noreferrer"
          key={link.label}
        >
          <span className="grid size-10 place-items-center rounded-full border border-ink/15 transition-colors duration-200 group-hover:border-accent/50 group-hover:text-accent">
            <span className="size-[19px]">
              <Icon name={link.icon} />
            </span>
          </span>

          <span className="flex min-w-0 flex-col gap-[5px]">
            <strong className="text-[15px] font-medium">{link.label}</strong>
            <small className="font-mono text-[9px] tracking-[.14em] text-ink/60 uppercase">
              {link.detail}
            </small>
          </span>

          <span className="grid size-[18px] place-items-center transition-[color,transform] duration-200 group-hover:translate-x-1 group-hover:text-accent">
            <Icon name="arrow" />
          </span>
        </a>
      ))}
    </nav>
  );
}
